import { PcApiResponse } from '@/api/pc-api/types';
import { DetailInfo } from '@/api/pc-api/v1/{authInfoId}/settle-base-info';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export const getSettleBaseDetailInfo = (settleId: string) => {
  return api<PcApiResponse<DetailInfo>>('get', `/pc-api/v1/${PREFIX_PATH}/settle-base-info/settle-base-detail-info`, {
    settleId
  });
};
